// extracted by mini-css-extract-plugin
var _1 = "oSa74";
var _2 = "vrBoo";
var _3 = "tK1kn";
export { _1 as "base", _2 as "errorBanner", _3 as "title" }
